import { render, staticRenderFns } from "./HeaderMiddle.vue?vue&type=template&id=efc335c0&"
import script from "./HeaderMiddle.vue?vue&type=script&lang=js&"
export * from "./HeaderMiddle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports